<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M176 128C167.2 128 160 135.2 160 144L160 496C160 504.8 167.2 512 176 512L240 512C248.8 512 256 504.8 256 496L256 144C256 135.2 248.8 128 240 128L176 128zM128 144C128 117.5 149.5 96 176 96L240 96C266.5 96 288 117.5 288 144L288 496C288 522.5 266.5 544 240 544L176 544C149.5 544 128 522.5 128 496L128 144zM400 128C391.2 128 384 135.2 384 144L384 496C384 504.8 391.2 512 400 512L464 512C472.8 512 480 504.8 480 496L480 144C480 135.2 472.8 128 464 128L400 128zM352 144C352 117.5 373.5 96 400 96L464 96C490.5 96 512 117.5 512 144L512 496C512 522.5 490.5 544 464 544L400 544C373.5 544 352 522.5 352 496L352 144z"
      fill="currentColor"
    />
  </svg>
</template>
